<template>
    <div>
        <vue-content-loading :width="800" :height="60" :speed="2" primary="#d2d6dd" accent="#f2f3fc">

            <circle cx="30" cy="30" r="20" />

            <rect x="65" y="17" rx="5" ry="5" width="100" height="12" />


            <rect x="65" y="35" rx="5" ry="5" width="10" height="10" />
            <rect x="78" y="35" rx="5" ry="5" width="10" height="10" />
            <rect x="91" y="35" rx="5" ry="5" width="10" height="10" />
            <rect x="104" y="35" rx="5" ry="5" width="10" height="10" />
            <rect x="117" y="35" rx="5" ry="5" width="10" height="10" />


            <rect x="135" y="35" rx="5" ry="5" width="40" height="10" />

        </vue-content-loading>
        <vue-content-loading :width="300" :height="70" :speed="2" primary="#d2d6dd" secondary="#f2f3fc">
            <rect x="0" y="5" rx="0" ry="0" width="300" height="100" />
        </vue-content-loading>
    </div>
</template>

<script>
    import VueContentLoading from 'vue-content-loading';

    export default{
        components:{
            VueContentLoading
        }
    }
</script>
